export const HAS_CHEAPER_AND_FASTER = 'Has both a cheaper option and an option with the same or better delivery date';
export const HAS_CHEAPER = 'Has a cheaper option with the same or better delivery date';
export const HAS_FASTER = 'Has a faster delivery date with same or cheaper cost';
export const DONT_SHOW = 'No rate from carrier and seller specified "don\'t show"';
export const INACTIVE = 'Setting is inactive';
export const INCOMPLETE_ADDRESS = 'Skipped due to incomplete address';
export const NO_SERVICES = 'no services';
export const DUPLICATE_SERVICES = 'duplicate services';
export const BY_VOLUME = 'by-volume';
export const BY_CUSTOM_PACKAGE = 'by-custom-package';
export const SKIP_DIMENSIONS = 'skip-dimensions';
export const ALL_CALC_TYPE = 'all-types';
export const BY_WEIGHT_CALC_TYPE = 'by-weight';
export const BY_DIMENSIONS_CALC_TYPE = 'by-dimensions';
export const MAX_WEIGHT = 2147483647; // Int.MaxValue (or 2^31)

export const SIMILAR_OPTIONS_REASONS = [HAS_CHEAPER_AND_FASTER, HAS_CHEAPER, HAS_FASTER];

export const REQUIRED_ADDRESS_FIELDS = {
  countryCode: 'countryCode',
  line1: 'line1',
  city: 'city',
};

export const RESIDENTIAL = 'Residential';
export const COMMERCIAL = 'Commercial';

export const ADD = 'add';

export const SET_AMOUNT = 'setAmount';
export const PERCENTAGE_OF_CARRIER_RATE = 'percentageOfCarrierRate';
